import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-life-record-report-visit',
  templateUrl: './life-record-report-visit.component.html',
  styleUrls: ['./life-record-report-visit.component.scss']
})
export class LifeRecordReportVisitComponent implements OnInit {

  requestType : string = "visit";
  title : string = "Life Record - زيارات";

  constructor() { }

  ngOnInit() {
  }

}
